// extracted by mini-css-extract-plugin
module.exports = {"card-text-item-container":"CardTextItem_card-text-item-container__-ji98","title-container":"CardTextItem_title-container__1kgAW"};